var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Done_svg__c",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7bf596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4fdc6f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Done_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 16861",
    transform: "translate(1289 2811)",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h30v30H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Done_svg__b",
    x: 0,
    y: 1,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#5ce37b",
    floodOpacity: 0.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 368",
    transform: "translate(-1289 -2811)",
    clipPath: "url(#Done_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Check with background"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1289 2811)",
    filter: "url(#Done_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle Copy",
    width: 24,
    height: 24,
    rx: 12,
    transform: "translate(3 3)",
    fill: "url(#Done_svg__c)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1301.195 2828.884l-2.952-2.927a.607.607 0 010-.856l.9-.893a.607.607 0 01.862 0l2.691 2.679 5.587-5.133a.607.607 0 01.844 0l.9.917a.607.607 0 010 .85l-6.985 6.42a.607.607 0 01-.844 0l-.9-.917a.528.528 0 01-.1-.14z",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
export default SvgDone;